import Button from 'components/Button';
import {FC} from 'react';
import {Size} from 'types';
import getPreferredLanguage from 'utils/locale';

import usePostSetLang from '../services';

type ButtonLocaleProps = {
    className?: string;
    isAlignedCenter?: boolean;
    size?: Size;
};

const ButtonLocale: FC<ButtonLocaleProps> = ({
    className = '',
    isAlignedCenter = true,
    size = 'base',
}) => {
    const {mutateAsync} = usePostSetLang();
    const language = getPreferredLanguage();

    // The button shows the opposite value of what is currently set
    const [label, value] =
        language === 'en' ? ['日本語', 'ja'] : ['English', 'en'];

    return (
        <Button
            className={className}
            icon="language"
            isAlignedCenter={isAlignedCenter}
            kind="tertiary"
            onClick={() => {
                mutateAsync({
                    language: value,
                }).then(() => {
                    window.location.reload();
                });
            }}
            size={size}
        >
            {label}
        </Button>
    );
};

export default ButtonLocale;
